import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

// Social Icons
const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
  </svg>
);

// Configuration
const CONTACT_CONFIG = {
  phone: "+39 393 581 7177",
  email: "info@capevremuri.it",
  address: "Pala Ruffini, Viale Leonardo Bistolfi, 10, 10141 Torino TO",
  eventDate: "06 Aprile 2026",
  eventTime: "15:00",
  hours: [
    { day: "Luni - Vineri", time: "9:00 - 18:00" },
    { day: "Sâmbătă", time: "10:00 - 14:00" },
    { day: "Duminică", time: "Închis" },
  ],
  whatsapp: "https://wa.me/393935817177",
  instagram: "https://www.instagram.com/ca_pe_vremuri/",
  facebook: "https://www.facebook.com/people/Ca-Pe-Vremuri/61585590519188/",
  tiktok: "https://www.tiktok.com/@ca_pe_vremuri",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2818.5!2d7.6298!3d45.0789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47886d126a24ef55%3A0x7c42ae5b1e5c3f1b!2sViale%20Leonardo%20Bistolfi%2C%2010%2C%2010141%20Torino%20TO!5e0!3m2!1sit!2sit!4v1705916400000!5m2!1sit!2sit",
};

const Contact: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-romanian-blue to-primary-700 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-64 h-64 bg-romanian-yellow rounded-full blur-3xl" />
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-romanian-red rounded-full blur-3xl" />
        </div>

        <div className="container-custom relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <span className="text-romanian-yellow font-semibold text-sm uppercase tracking-wider">
              {t.nav.contact}
            </span>
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 mb-6">
              {t.contact.title}
            </h1>
            <p className="text-white/90 text-lg md:text-xl leading-relaxed">
              {t.contact.subtitle}
            </p>
          </div>
        </div>

        {/* Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none">
            <path
              d="M0 120L48 110C96 100 192 80 288 70C384 60 480 60 576 65C672 70 768 80 864 85C960 90 1056 90 1152 85C1248 80 1344 70 1392 65L1440 60V120H0Z"
              fill="#fafafa"
            />
          </svg>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section bg-gray-50">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto">
            {/* Contact Info */}
            <div className="space-y-8">
              <div>
                <h2 className="font-display text-3xl font-bold text-romanian-blue mb-6">
                  {t.contact.contactInfo}
                </h2>
                <p className="text-gray-600 mb-8">
                  {t.contact.contactDescription}
                </p>
              </div>

              {/* Contact Cards */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <a
                  href={`tel:${CONTACT_CONFIG.phone.replace(/\s/g, "")}`}
                  className="card p-6 flex items-start space-x-4 hover:shadow-xl transition-shadow"
                >
                  <div className="p-3 bg-romanian-blue rounded-lg text-white">
                    <Phone className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">
                      {t.contact.phone}
                    </h3>
                    <p className="text-romanian-blue font-medium">
                      {CONTACT_CONFIG.phone}
                    </p>
                  </div>
                </a>

                <a
                  href={`mailto:${CONTACT_CONFIG.email}`}
                  className="card p-6 flex items-start space-x-4 hover:shadow-xl transition-shadow"
                >
                  <div className="p-3 bg-romanian-blue rounded-lg text-white">
                    <Mail className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">
                      {t.contact.email}
                    </h3>
                    <p className="text-romanian-blue font-medium break-all">
                      {CONTACT_CONFIG.email}
                    </p>
                  </div>
                </a>

                <div className="card p-6 flex items-start space-x-4 sm:col-span-2">
                  <div className="p-3 bg-romanian-blue rounded-lg text-white">
                    <MapPin className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">
                      {t.contact.address}
                    </h3>
                    <p className="text-gray-600">{CONTACT_CONFIG.address}</p>
                  </div>
                </div>
              </div>

              {/* Event Date & Time */}
              <div className="card p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="p-3 bg-romanian-yellow rounded-lg text-romanian-blue">
                    <Clock className="w-6 h-6" />
                  </div>
                  <h3 className="font-semibold text-gray-900">
                    {t.contact.eventDateTime}
                  </h3>
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between text-gray-600">
                    <span>{t.contact.date}</span>
                    <span className="font-medium text-romanian-blue">
                      06 Aprile 2026
                    </span>
                  </div>
                  <div className="flex justify-between text-gray-600">
                    <span>{t.contact.time}</span>
                    <span className="font-medium text-romanian-blue">
                      15:00
                    </span>
                  </div>
                </div>
              </div>

              {/* Social Links */}
              <div className="card p-6">
                <h3 className="font-semibold text-gray-900 mb-4">
                  {t.contact.followUs}
                </h3>
                <div className="flex items-center space-x-4">
                  <a
                    href={CONTACT_CONFIG.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 bg-green-100 rounded-xl text-green-600 hover:bg-green-500 hover:text-white transition-colors"
                    aria-label="WhatsApp"
                  >
                    <WhatsAppIcon />
                  </a>
                  <a
                    href={CONTACT_CONFIG.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 bg-pink-100 rounded-xl text-pink-600 hover:bg-gradient-to-br hover:from-purple-500 hover:to-pink-500 hover:text-white transition-all"
                    aria-label="Instagram"
                  >
                    <InstagramIcon />
                  </a>
                  <a
                    href={CONTACT_CONFIG.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 bg-blue-100 rounded-xl text-blue-600 hover:bg-blue-600 hover:text-white transition-colors"
                    aria-label="Facebook"
                  >
                    <FacebookIcon />
                  </a>
                  <a
                    href={CONTACT_CONFIG.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-4 bg-gray-100 rounded-xl text-gray-700 hover:bg-black hover:text-white transition-colors"
                    aria-label="TikTok"
                  >
                    <TikTokIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="section bg-white pt-0">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl font-bold text-romanian-blue mb-4">
              {t.contact.whereWeAre}
            </h2>
            <p className="text-gray-600">{t.contact.whereWeAreDescription}</p>
          </div>

          <div className="card overflow-hidden">
            <iframe
              src={CONTACT_CONFIG.mapEmbedUrl}
              width="100%"
              height="500"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Location Map"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
